import React from 'react'
import { createBrowserHistory } from 'history'
import { ThemeProvider } from 'react-jss'

import App from './app-view'
import { EndUserProvider, ConfigurationProvider } from '@portal/kit/pkg/components'
import { RanProvider, withRan } from 'components/providers/ran'
import SubscriptionProvider from 'components/providers/subscription'

const history = createBrowserHistory()

const endUserProps = {
  onLogin: () => {
    history.replace('/')
  },
  onLogout: () => {
    if (history.location.pathname !== '/login') {
      history.replace('/login')
    }
  }
}

const EndUserProviderRan =
  withRan(props =>
    <EndUserProvider {...endUserProps} onSetUser={props.loadRanRooms}>
      <SubscriptionProvider>
        <App history={history} />
      </SubscriptionProvider>
    </EndUserProvider>
  )

const AppContainer = () =>
  <ConfigurationProvider>
    {portalConfiguration => (
      <ThemeProvider theme={portalConfiguration || {}}>
        <RanProvider>
          <EndUserProviderRan />
        </RanProvider>
      </ThemeProvider>
    )}
  </ConfigurationProvider>

export default AppContainer
